var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"foo"}},[_vm._v("\n  "+_vm._s(_vm.$t('titles.posts.edit'))+"\n  "),_c('edit-post-form',{attrs:{"post":_vm.myPost}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }